module.exports = __webpack_public_path__ + "static/img/QQ1.6042ffe3.svg";